import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Alert, Icon, ScrollBox, Table } from '~/components/blocks';
import { patientPageInfoState } from '~/state/patient/atoms';

import { AllPatient } from './AllPatient';
import { SamePatientModal } from './AllPatient/SamePatientModal';
import { useFetchAllPatients } from './use-fetch-all-patients';

const Sort = styled('span')(() =>
  css({
    cursor: 'pointer',
  }),
);

export const AllPatientList = () => {
  const theme = useTheme();
  const { loading, allPatients, scrollRef } = useFetchAllPatients();
  const [pageInfo, setPageInfo] = useAtom(patientPageInfoState);

  const handleClickMessageSendAtOrder = useCallback(
    (direction: 'asc' | 'desc') =>
      setPageInfo((_pageInfo) => ({
        ..._pageInfo,
        orderBy: { field: 'latest_message_created_at', direction },
      })),
    [setPageInfo],
  );

  return (
    <ScrollBox ref={scrollRef} loading={loading}>
      <Table appearance="noline" marginTop={theme.space.m} whiteSpace="nowrap">
        <Table.Thead>
          <Table.Tr>
            <Table.Th>患者名</Table.Th>
            <Table.Th></Table.Th>
            <Table.Th>送信先</Table.Th>
            <Table.Th>
              メッセージ最終作成日時
              {pageInfo.orderBy.field === 'latest_message_created_at' &&
              pageInfo.orderBy.direction === 'asc' ? (
                <Sort onClick={() => handleClickMessageSendAtOrder('desc')}>
                  <Icon size="m" icon="arrow-down" />
                </Sort>
              ) : (
                <Sort onClick={() => handleClickMessageSendAtOrder('asc')}>
                  <Icon size="m" icon="arrow-top" />
                </Sort>
              )}
            </Table.Th>
            <Table.Th></Table.Th>
            <Table.Th>質問票回答</Table.Th>
            <Table.Th>フォローアップメモ</Table.Th>
            <Table.Th>送信者</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {allPatients.map((allPatient, idx) => {
            return <AllPatient key={idx} allPatient={allPatient} />;
          })}
        </Table.Tbody>
      </Table>
      {!loading && allPatients.length === 0 && (
        <Alert status="info" mt={theme.space.m}>
          条件に一致する患者は見つかりませんでした
        </Alert>
      )}
      <SamePatientModal />
    </ScrollBox>
  );
};
